import React, { useState, useEffect } from 'react';
import { useAuthDispatch, updateVideoCallStatus, setOrgData} from '../context/';
import Request from '../components/AxiosInstance';
import Container from '@mui/material/Container';
// import Typography from '@mui/material/Typography';

import CurrentProcedure from '../components/CurProcedure';
// import PreviousProcedureList from '../components/PrevProcedure';
import TelehealthConsentForm from '../components/TelehealthConsentForm';

export default function ProcedurePage () {
	const dispatch = useAuthDispatch();
	// const [pageIndex, setPageIndex] = useState(0);
	const [curPcdState, setCurPcdState] = useState({
		id: null,
		physicianFullName: '',
		refphyFullName: '',
		sn: '',
		status: '',
		ingestionTime: null,
		procedureDate: null,
		shippingLabel: null,
		shippingCarrier: null,
		videoReady: false,
		reportReady: false,
		telehealthConsentDone: false,
		officePhone: '',
		organizationName: '',
		organizationAvatarUrl: null,
		videoCallEnabled: false
	})
	const [telehealthFormsContent, setTelehealthFormsContent] = useState({
		teleConsent: '',
	});
	const [loadingForms, setLoadingForms] = useState(true);
	const [accountInfo, setAccountInfo] = useState({ fullName: '' }); // Add state for account info

	// const [prevPcd, setPrevPcd] = useState([]);
	
	// State for managing form popups
	const [showConsentForm, setShowConsentForm] = useState(false);

	const getProceduresAndForms = async () => {
		try {
			setLoadingForms(true);
			// Fetch procedures first
			const curPcd = await Request.get('/api/capsule/');
			const hasScheduledCall = curPcd.status === 'scheduled';
			updateVideoCallStatus(dispatch, hasScheduledCall);
			setCurPcdState(curPcd);
			setOrgData(dispatch, {
				organizationAvatarUrl: curPcd.organizationAvatarUrl,
				organizationName: curPcd.organizationName,
				officePhone: curPcd.officePhone
			});

			// Fetch account info for full name
			try {
				const accInfo = await Request.get('/api/account/info');
				setAccountInfo(accInfo);
			} catch (accError) {
				console.error("Error fetching account info:", accError);
			}

			// Fetch form content only if needed
			if (!curPcd.telehealthConsentDone) {
				try {
					const formsContent = await Request.get('/api/tos/telehealth');
					setTelehealthFormsContent(formsContent);
				} catch (formError) {
					console.error("Error fetching telehealth forms content:", formError);
					// Handle error, maybe disable forms or show error
				}
			}

			// Determine which form to show
			if (!curPcd.telehealthConsentDone) {
				setShowConsentForm(true);
			}
		} catch (error) {
			console.error("Error fetching procedures:", error);
		} finally {
			setLoadingForms(false);
		}
	}

	// Handle successful consent form submission
	const handleConsentSuccess = () => {
		setCurPcdState(prevState => ({
			...prevState,
			telehealthConsentDone: true
		}));
		setShowConsentForm(false);
	};

	// Use useEffect to call the fetch function on mount
	useEffect(() => {
        getProceduresAndForms();
    }, []);

	const renderCurrentProcedurePage = (curProcedure) => {
		return (
			<Container
				component="main"
				maxWidth="lg"
				sx={{
					pt: 2,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					minHeight: '75vh'
				}}>
				<CurrentProcedure curProcedure={curProcedure} />
			</Container>
		)
	}

	/* const renderPreviousProcedurePage = () => {
		return (
			<Container
				component="main"
				maxWidth="md">
				<Typography variant="h5">Past Appointments</Typography>
				<PreviousProcedureList prevPcdList={prevPcd} />
			</Container>
		)
	} */

	const renderProcedurePage = (pageIndex) => {
		if (pageIndex === 0 ) {
			return renderCurrentProcedurePage(curPcdState);
		}
	}

	return (
		<Container sx={{
			display: 'flex',
			flexDirection: 'column',
			minWidth: '100%'
		}}>
			
			{/* Risk Assessment Form - Hide if telehealthHasRisk is true */}

			{/* Consent Form */}
			{!loadingForms && telehealthFormsContent.teleConsent && (
				<TelehealthConsentForm
					open={showConsentForm}
					onClose={() => setShowConsentForm(false)} 
					onSubmitSuccess={handleConsentSuccess}
					procedureId={curPcdState?.id}
					formContentHtml={telehealthFormsContent.teleConsent}
					expectedFullName={accountInfo.firstName && accountInfo.lastName ? `${accountInfo.firstName} ${accountInfo.lastName}` : accountInfo.fullName || ''}
				/>
			)}

			{/* <Container component="main" maxWidth="lg" sx={{ pt: 2 }}>
				{ pageIndex === 0 ? (
					<Chip icon={<EventAvailableIcon />} label="Past Appointments" variant="outlined" onClick={() => setPageIndex(1)} />
				) : (
					<Chip icon={<AccessTimeIcon />} label="Current Appointment"  variant="outlined" onClick={() => setPageIndex(0)} />
				)}
			</Container> */}
			<Container component="main" maxWidth="lg" sx={{ pt: 2 }}>
				{ renderProcedurePage(0) }
			</Container>
		</Container>
	);
}
